import React, { Fragment } from "react";
import { Row } from "reactstrap";
import GiftCardBrandedIcon from "../../images/gift-card-branded.svg";
import GiftCardCustomIcon from "./../../images/gift-card-custom.svg";
import DigitalCardIcon from "./../../images/digitalcard.svg";
import PrintCardIcon from "./../../images/print-card.svg";
import HonorCardIcon from "./../../images/honor-card.svg";
import RedemptionCodesIcon from "./../../images/redemption-codes.svg";
import DonateIcon from "./../../images/donate.svg";
import DonateBalanceIcon from "./../../images/donate-balance.svg";
import SinglePurchaseItem from "./SinglePurchaseItem";

export default function PurchaseItems(props) {
  return (
    <Fragment>
      <Row className="justify-content-center">
        <SinglePurchaseItem
          caption="Physical Cards"
          icon={GiftCardBrandedIcon}
          iconAlt="Buy the best charity gift cards for friends and clients. Holiday, Birthday, Seasons Greetings and Christmas Stocking Stuffers."
          text="Gift cards with one of our branded, occasion designs."
          url="/Purchase/PhysicalCards"
          buttonText="Give Physical Cards"
        />
        <SinglePurchaseItem
          caption="Digital Cards"
          icon={DigitalCardIcon}
          iconAlt="Send your best last-minute eGifts as eCards, text messages or post directly to friend’s platform - Facebook, Twitter etc."
          text="Select a card to share by email, text, or social media."
          url="/Purchase/eCards"
          buttonText="Give Digital Cards"
        />
      </Row>
      <Row className="justify-content-center">
        <SinglePurchaseItem
          caption="Honor Cards"
          icon={HonorCardIcon}
          iconAlt="CharityChoice Honor Cards"
          text='Make a donation to the charity of your choice "in honor of" your recipient.'
          url="/Purchase/HonorCards"
          buttonText="Give Honor Cards"
        />
        <SinglePurchaseItem
          caption="Print Your Own Cards"
          icon={PrintCardIcon}
          iconAlt="Print Your Own Cards"
          text="Receive a high-quality PDF card to print at home."
          url="/Purchase/PrintCards"
          buttonText="Give Printable Cards"
        />
      </Row>
      <Row className="justify-content-center">
        <SinglePurchaseItem
          caption="Custom Gift Cards"
          icon={GiftCardCustomIcon}
          iconAlt="Donate to purchase charity gift cards. Plastic Custom plastic and Digital eGifts. Tax deductible, the best gifting idea."
          text={
            <Fragment>
              Corporate and Events: Customize bulk physical cards
              <br />
              with your logo or your own, branded artwork.
            </Fragment>
          }
          url="/Purchase/CustomPhysicalCards"
          buttonText="Give Custom Cards"
        />
        <SinglePurchaseItem
          caption="Redemption Codes"
          icon={RedemptionCodesIcon}
          iconAlt="CSV file of redemption codes for clients. Redeem gift card for top, highly rated charities. Best nonprofits - local, national and International."
          text={
            <Fragment>
              Buy unique codes to download and distribute
              <br />
              using your own materials via any method you wish.
            </Fragment>
          }
          url="/Purchase/RedemptionCodes"
          buttonText="Buy Redemption Codes"
        />
      </Row>
      <Row className="justify-content-center">
        <SinglePurchaseItem
          caption="Make A Direct Donation"
          icon={DonateIcon}
          iconAlt="Donate to charity"
          text="Use your credit card to donate through us to a specific charity."
          url="/Purchase/DirectToCharityDonation"
          buttonText="Donate Directly"
        />
        <SinglePurchaseItem
          caption="Donate Gift Card Balance"
          icon={DonateBalanceIcon}
          iconAlt="Donate Gift Card Balance"
          text="Use your retail gift card balance to make a donation to a charity."
          url="/GCE"
          buttonText="Donate Balance"
        />
      </Row>
      <Row className="justify-content-center">
        <SinglePurchaseItem
          caption="Bulk Discount"
          icon={HonorCardIcon}
          iconAlt="Discount for a Charity Message to all Friends and Clients"
          text="Discount for a Charity Message to all Friends and Clients"
          url="/Purchase/BulkDiscount"
          buttonText="Bulk Discount"
        />
      </Row>
    </Fragment>
  );
}
